// contains old format for displaying validation failure
import APP_ERROR from '../constants/appErrors';

const getErr = APP_ERROR;

class HandleResponses {
  static Status(result) {
    let text = '';
    const status = result.status;
    let { code, data, message, field } = (result.data && result.data.errors && result.data.errors.length) ?
      result.data.errors[0] : { };
    if (!data && result.data) {
      data = result.data;
    }

    switch (status) {
      case 204:
        return { success: 'OK' };
      case 400:
        if (code && data && data.length) {
          text = getErr[code] + data.toString();
        } else if (code && getErr[code]) {
          text = getErr[code];
        } else if (message) {
          text = `${message} - ${getErr.VALIDATION_FAILS}`;
        } else {
          text = getErr['400'];
        }
        return { error: text };

      case 401:
        return { error: getErr['401'] };

      case 426:
      case 409:
        if (status && data && data.length) {
          text = `${getErr[status]} - ${data.toString()}`;
        } else {
          text = getErr[status];
        }
        return { error: text };
      case 403:
        return { error: getErr['403'] };

      case 404:
        return { error: getErr['404'] };

      case 500:
        return { error: getErr['500'] };

      case 503:
        return { error: getErr['503'] };
      case 504:
        return { error: getErr['504'] };

      default:
        return { response: getErr.GENERAL_ERR };
    }
  }
}

export default HandleResponses;
